import { BASE_URL } from '@/lib/constants';
import type { IVerifyReferrerBody, IVerifyEmailBody, IVerifyUserBody, IVerifyEmailCodeBody } from './types';
import { IVerifyUserResponse } from '@/types';

const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const postVerifyReferrer = async (body: IVerifyReferrerBody) => {
  const response = await fetch(`${BASE_URL}/auth/verify/referrer`, {
    method: 'POST',
    body: JSON.stringify({ ...body }),
    headers: defaultHeaders
  });

  const data = await response.json();
  if (response.ok) {
    return data;
  }
  throw data;
};

const postVerifyEmail = async (body: IVerifyEmailBody) => {
  const response = await fetch(`${BASE_URL}/auth/verify/email`, {
    method: 'POST',
    body: JSON.stringify({ ...body }),
    headers: defaultHeaders,
  });

  const data = await response.json();
  if (response.ok) {
    return data;
  }

  throw data;
};

const postVerifyUser = async (body: IVerifyUserBody): Promise<IVerifyUserResponse> => {
  const response = await fetch(`${BASE_URL}/auth/verify/user`, {
    method: "POST",
    body: JSON.stringify({ ...body }),
    headers: defaultHeaders
  });

  const data = await response.json();
  if (response.ok) {
    return data;
  }
  throw data;
};

const postVerifyEmailCode = async (body: IVerifyEmailCodeBody) => {
  const response = await fetch(`${BASE_URL}/auth/verify/email/code`, {
    method: "POST",
    body: JSON.stringify({ ...body }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();
  if (response.ok) {
    return data;
  }
  throw data;
};
  
export { postVerifyReferrer, postVerifyEmail, postVerifyUser, postVerifyEmailCode };
